import React from 'react';
import AIWorksheetBuilder from './components/AIWorksheetBuilder.jsx';

export default function WorksheetGenerator() {
    return <AIWorksheetBuilder />;
}
